/**
 * @fileoverview CSS wrapper for One To One components.
 * Uses `<Global />` from emotion to inject CSS to custom
 * component Shadow DOM root.
 */

import { css, Global } from '@emotion/react'
import { OTO_CSS } from '@oneToOne/shared/styles'

import {
  GLOBAL_COL_STYLE,
  GLOBAL_ROW_STYLE,
} from '@core/components/Layout/Grid/GlobalGridCSS'
import { CSS_COLORS } from '@core/styles/colors'
import { FONT_FAMILY } from '@core/styles/cssVariables'
import { CSS_RESET } from '@core/styles/reset'
import { loadTheme } from '@core/styles/themes'
import { cssVar, cssVarsFromTheme } from '@core/styles/tools'
import { VARIABLES as SHARED } from '@core/styles/variables'

interface IProps {
  themeName?: string
  bottomPadding?: number
  scope?: string
}

/**
 *
 */
export function GlobalCustomCSS(props: IProps): React.ReactElement<any> {
  const { themeName, scope = ':host', bottomPadding } = props
  const theme = loadTheme(themeName)

  return (
    <>
      <Global
        styles={css`
          ${scope} {
            ${CSS_RESET}
            ${CSS_COLORS}

            font-family: var(${FONT_FAMILY}, inherit);

            /* Process theme variables into desired format */
            ${cssVarsFromTheme(theme)}

            /* Shared global variables supposed to be used by all Zeffo products */
            ${SHARED.map((args) => cssVar(...args)).join('\n')}

            ${cssVar(
              ...[
                '--live-helper-bottom',
                {
                  fallback: bottomPadding
                    ? `${bottomPadding}px`
                    : 'var(--spacing-16)',
                  external: true,
                },
              ],
            )}

            ${OTO_CSS}
            ${GLOBAL_COL_STYLE}
            ${GLOBAL_ROW_STYLE}
          }
        `}
      />
    </>
  )
}
